/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    greyOutlinedButton: {
        left: 0,
        fontFamily: 'GilmerMedium',
        fontSize: '12px',
        lineHeight: '14px',
        color: '#40404B',
        height: theme.spacing(5),
        width: theme.spacing(10)
    },
    generateButton: {
        fontFamily: 'GilmerMedium',
        fontSize: 12,
        lineHeight: 1,
        fontStretch: "normal",
        height: theme.spacing(5),
        marginTop: theme.spacing(0.5),
        width: 'auto',
    },
    dialog: {
        borderRadius: theme.spacing(1.5)
    },
    dialogTitle: {
        textAlign: "center",
        paddingBottom: theme.spacing(0),
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(1.5)
    },
    titleText: {
        lineHeight: '64px',
        fontFamily: 'GilmerBold',
        color: '#222228',
        fontSize: '29px'
    },
    keyInfo: {
        backgroundColor: '#F0F1FB',
        borderLeftStyle: 'solid',
        borderLeftColor: '#5567D5',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
    infoHeader: {
        fontFamily: 'GilmerMedium',
        fontSize: '13px',
        lineHeight: '24px',
        color: '#1D2028'
    },
    infoText: {
        fontFamily: 'Gilmer',
        lineHeight: '20px',
        color: theme.palette.secondary.dark,
        width: '90%'
    },
    infoIcon: {
        color: '#5567D5',
        fontSize: 'large'
    },
    dialogContent: {
        marginBottom: theme.spacing(0.5)
    },
    action: {
        padding: `${theme.spacing(0.5)}px ${theme.spacing(3)}px ${theme.spacing(2)}px`
    },
    permissionList: {
        marginTop: theme.spacing(3),
    },
    permissionChip: {
        backgroundColor: theme.palette.secondary.light,
        border: '1px solid #CBCEDB',
        borderRadius: theme.spacing(0.625),
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
        justifyContent: 'left',
        width: 'fit-content'
    },
    permissionContainer: {
        marginTop: theme.spacing(1),
        color: theme.palette.secondary.dark,
    },
    textField: {
        width: '100%',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.75),
        '& .MuiOutlinedInput-input': {
          color: theme.palette.grey[500],
          paddingLeft: theme.spacing(1),
        },
        '& .MuiOutlinedInput-root': {
          minHeight: theme.spacing(4),
          height: 'auto',
        },
    },
    tag: {
        '& .MuiAutocomplete-tag': {
            height: theme.spacing(3),
            borderRadius: theme.spacing(0.625),
            border: "1px solid #E0E2E9",
            backgroundColor: theme.palette.secondary.light,
            "& .MuiChip-label": {
              color: theme.palette.secondary.dark,
            },
            "& .MuiChip-deleteIcon": {
              color: theme.palette.secondary.main,
            },
        },
    },
    loaderContainer: {
        width: "100%",
        height: "30vh",
        backgroundColor: theme.palette.secondary.light,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...theme.custom.appListingPage.styles
    },
}));
